export default function() {
  return !this.node();
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-selection/src/selection/empty.js
// module id = 278
// module chunks = 0